goog.provide("shadow.js.shim.module$$mui$material$MenuList$default");
shadow.js.shim.module$$mui$material$MenuList$default = shadow.js.shim.module$$mui$material$MenuList.default;
